import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { LeaderboardPeriod } from "@uno/protocol";

type Props = {
    active: LeaderboardPeriod;
    onChange: (period: LeaderboardPeriod) => void;
    weekIsoNumber?: number | null;
};

const VIEWS: { id: LeaderboardPeriod; labelKey: string }[] = [
    { id: "weekly", labelKey: "leaderboard.view_weekly" },
    { id: "alltime", labelKey: "leaderboard.view_alltime" },
];

const PeriodToggle: React.FC<Props> = ({ active, onChange, weekIsoNumber }) => {
    const { t } = useTranslation();

    const labelFor = (view: (typeof VIEWS)[number]) => {
        if(view.id === "weekly" && active === "weekly" && weekIsoNumber !== null && weekIsoNumber !== undefined) {
            return t("leaderboard.week_label", { week: weekIsoNumber });
        }

        return t(view.labelKey);
    };

    return (
        <div className="relative flex items-center gap-1 p-1 rounded-full bg-white/10 border border-white/10">
            {VIEWS.map((view) => (
                <button
                    key={view.id}
                    onClick={() => onChange(view.id)}
                    className={`relative px-5 py-2 rounded-full font-changa-one text-xs md:text-sm tracking-[0.2em] transition-colors cursor-pointer ${
                        active === view.id
                            ? "text-white"
                            : "text-white/40 hover:text-white/60"
                    }`}
                >
                    {active === view.id && (
                        <motion.div
                            layoutId="lb-view-indicator"
                            className="absolute inset-0 rounded-full bg-white/15"
                            transition={{ type: "spring", stiffness: 400, damping: 30 }}
                        />
                    )}
                    <span className="relative z-10">{labelFor(view)}</span>
                </button>
            ))}
        </div>
    );
};

export default PeriodToggle;
